export class CrossSellMiniCart extends HTMLElement {
  connectedCallback() {

    this.slider       = this.querySelector('.container-slider');
    this.bestSelling  = this.querySelector('[data-element="add-best-selling"]');

    this._loadProduct().then(response => {
      if (response){
        this._initSliders();
      }
    });

  }
  _setMiniCartHeight() {
    let miniCartHeader = document.querySelector('.mini-cart__header');
    let miniCartSuggestion = document.querySelector('.cart-item-suggestion');
    let miniCartContent = document.querySelector('.mini-cart__items-container');
    let miniCartFooter = document.querySelector('.mini-cart__footer');
    let height = window.innerHeight;
    let miniCart = document.querySelector('#mini-cart-section');

    if (miniCartHeader) {
      height = height - miniCartHeader.offsetHeight;
    }

    if (miniCartSuggestion) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        height = height - (miniCartSuggestion.offsetHeight + 25);
      } else {
        height = height - (miniCartSuggestion.offsetHeight + 32);
      }
    }

    if (miniCartFooter) {
      height = height - miniCartFooter.offsetHeight;
    }

    if (miniCartContent) {
      miniCartContent.style.height = height + 'px';
    }

    if (miniCart) {
      miniCart.style.height = window.innerHeight + 'px';
    }
  }

  _initSliders() {
    // fix Flickity slider
    if (this.slider) {

      if (this.slider.querySelectorAll('.mini-cart__cross-sell-product-container').length > 2 || window.matchMedia('(max-width:560px)').matches) {
        this.slider.classList.remove('no-slider');

        this.mainslider = new Flickity(this.slider, {
          cellAlign: 'left',
          prevNextButtons: true,
          groupCells: 1,
          cellSelector: '.mini-cart__cross-sell-product-container',
          wrapAround: true,
          pageDots: false,
          on: {
            ready: function () {
              // inject arrows
              this.prevButton.element.innerHTML = '<svg viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6.502H1.994" stroke="#262626" stroke-width="2" stroke-miterlimit="10"/><path d="M6.673 1.689l-4.82 4.82 4.82 4.82" stroke="#262626" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/></svg>';
              this.nextButton.element.innerHTML = '<svg viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.498h10.006" stroke="#262626" stroke-width="2" stroke-miterlimit="10"/><path d="M5.327 11.311l4.82-4.82-4.82-4.82" stroke="#262626" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/></svg>';
            }
          }
        });
      } else {
        this.slider.classList.add('no-slider')
      }

      this._setMiniCartHeight();
    }
  }

  async _loadProduct() {

    let collection   = this.bestSelling.getAttribute('data-cat');
    let currentID    = this.bestSelling.getAttribute('data-current');

    if (this.bestSelling && collection) {

      let url = window.location.origin + '/collections/' + collection + '?view=cross-sell-ajax&sort_by=best-selling&id=' + currentID ;

      const response = await fetch(url)
      .catch((error) => {
        // Request failed
        console.error(error);
      });

      if (response.ok) {
        this.bestSelling.innerHTML = await response.text();
          return response
      }
    }
  }
}

try {
  window.customElements.define('cross-sell-mini-cart', CrossSellMiniCart);
} catch(e) {}